var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6171",
    "data-name": "Group 6171",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.683,
    height: 68.683,
    viewBox: "0 0 68.683 68.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47457",
    "data-name": "Path 47457",
    d: "M34.341,0A34.341,34.341,0,1,0,68.683,34.341,34.341,34.341,0,0,0,34.341,0ZM48.407,43.828a3.248,3.248,0,0,1,0,4.579,3.291,3.291,0,0,1-2.3.944,3.177,3.177,0,0,1-2.275-.944l-9.487-9.472-9.487,9.472a3.177,3.177,0,0,1-2.275.944,3.291,3.291,0,0,1-2.3-.944,3.248,3.248,0,0,1,0-4.579l9.472-9.487-9.472-9.487a3.238,3.238,0,0,1,4.579-4.579l9.487,9.487,9.487-9.487a3.238,3.238,0,0,1,4.579,4.579L38.92,34.341Z",
    fill: "#ff1919"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.50a55fefc33ae4cf13605532f134b2c0.svg";
export { ForwardRef as ReactComponent };